import { render } from "./AccesBlocat.vue?vue&type=template&id=28106ecc"
const script = {}

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__